





























































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CertificateEdit from './CertificateEdit';
import { VIPContact, VIPCertificate } from '@/loader';

@Component
export default class CertificateContactEdit extends CertificateEdit {
	@Prop({ type: Boolean, default: false })
	public noReplacement!: boolean;

	public focused = {
		civility: false,
		last_name: false,
		first_name: false,
		service: false,
		company: false,
		email: false,
	};

	public invalidFeedbacks = {
		civility: "",
		last_name: "Le nom ne peut pas être vide.",
		first_name: "Le prénom ne peut pas être vide.",
		service: "La fonction ne peut pas être vide.",
		company: "L'organisme ne peut pas être vide.",
		email: "L'email ne peut pas être vide.",
	};

	public get states() {
		return {
			civility: null,
			first_name: this.focused.first_name ? !!this.item.datas.contact.first_name?.trim() : null,
			last_name: this.focused.last_name ? !!this.item.datas.contact.last_name?.trim() : null,
			service: this.focused.service ? !!this.item.datas.contact.service?.trim() : null,
			company: this.focused.company ? !!this.item.datas.contact.company?.trim() : null,
			email: this.focused.email ? !!this.item.datas.contact.email?.trim() : null,
		};
	}

	public localContact: VIPContact | null = null;

	public get contact(): VIPContact | null {
		return this.localContact;
	}
	public set contact(value: VIPContact | null) {
		this.localContact = value;
		this.item.datas.fk_contact = value?.id || 0;
	}

	public replaceContactInfo() {
		if (!this.contact || !this.item || !this.canEdit) {
			return;
		}

		if (!this.item.datas.contact) {
			this.$set(this.item.datas, "contact", {
				civility: "",
				last_name: "",
				first_name: "",
				service: "",
				company: "",
				email: "",
			});
		}

		this.item.datas.contact.civility = this.contact.getCivilityLabel();
		this.item.datas.contact.first_name = this.contact.first_name;
		this.item.datas.contact.last_name = this.contact.last_name;
		this.item.datas.contact.email = this.contact.email;
		this.item.datas.contact.service = this.contact.position;
		this.item.datas.contact.company = this.contact.company?.name || this.item.project?.company?.name || "";
		this.setChanged(true);
	}

	@Watch("item", { immediate: true })
	public checkContact(newValue?: VIPCertificate, oldValue?: VIPCertificate) {
		if (newValue && newValue !== oldValue) {
			if (!newValue.datas.contact) {
				this.$set(newValue.datas, "contact", {
					civility: "",
					last_name: "",
					first_name: "",
					service: "",
					company: "",
					email: "",
				});
			}
		}
	}
}
